export default __webpack_public_path__ + "img/1089f1faccb765ed4319c770cc5b0b84.svg";